angular.module('smartorg.r6.mgmts.importPortfolio').directive("importPortfolio", [function () {
        return {
            restrict: 'E',
            template: require('../../template/import-portfolio.html'),
            transclude: true,
            scope: {
                astro: '=?',
                importPortfolioFromExport: '&'
            },
            link: function (scope) {
                scope.$on('manage:ImportPortfolio', function () {
                    function decodeAndStrip(response, i) {
                        var tmp = atob(decodeURIComponent(response.encodedExportedPortfolioList[i]).replace(/\s/g, ''));
                        scope.unstrippedPathList.push(tmp);
                        return tmp.replace('/opt/rangal/1.0.0/tmp/export/', '').replace('/', ' ');
                    }
                    scope.astro.fetchAllExportedPortfolioPaths()
                        .then(function (response) {
                        scope.includeData = true;
                        scope.portfolioPathList = [];
                        scope.unstrippedPathList = [];
                        for (var i = 0; i < response.encodedExportedPortfolioList.length; i++) {
                            scope.portfolioPathList.push(decodeAndStrip(response, i));
                        }
                        scope.$apply();
                    });
                });
                scope.selectedPortfolio = function (selected) {
                    scope.selected = selected;
                };
                scope.importPortfolio = function (newPortfolioName, includeData) {
                    var pathToImportFiles64 = btoa(scope.unstrippedPathList[scope.portfolioPathList.indexOf(scope.selected)]);
                    scope.importPortfolioFromExport({
                        includeData: includeData,
                        pathToImportFiles64: pathToImportFiles64,
                        newPortfolioName: newPortfolioName
                    });
                };
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }]);
//# sourceMappingURL=import-portfolio-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/import-portfolio/app/js/plumbing/import-portfolio-directive.js